module.exports = __webpack_public_path__ + "static/media/mongodb.b10b140c.png";